import React, { Component, lazy, Suspense } from "react";
import { inject, observer } from "mobx-react";
import withCustomStyles from "./ProductDetailPage.style";
import classnames from "classnames";
import AddToCartButtonPart from "../parts/AddToCartButtonPart";
import { timeDiffBreakdown } from "../utils/DateUtils";
import BreadcrumbsPart from "../parts/BreadcrumbsPart";
import {
  dealPrice,
  firstBrandName,
  getProductId,
  isDeal,
  isFlashDeal,
  productAvailability,
  productIsAvailable,
  productPrice,
  remindMe,
  hasFlashDealStarted,
  isFlashDealExpired,
  trimStr
} from "../utils/ProductUtils";
import {
  getProductAllFullImages,
  getProductPageAbsUrl,
  productFullImage,
  getImage,
  getSearchPageUrl,
  getProductPageUrl,
  getQueryParam,
  getProductIdFromUrl,
  getBrandPageUrl
} from "../utils/UrlUtils";
import { Link } from "react-router-dom";
import LocalShippingOutlined from "@material-ui/icons/LocalShippingOutlined";
import CardMembership from "@material-ui/icons/CardMembership";
import AssignmentReturnOutlined from "@material-ui/icons/AssignmentReturnOutlined";
import { GBadge, GButton, GDialog, GRow } from "../parts/ui";
import { isEasyPaisaMiniApp } from "../utils/AppUtils";
import {
  formatDiscount,
  formatPackSize,
  formatPrice
} from "../utils/FormatUtils";
import { withSnackbar } from "notistack";
import ImageWithLoaderPart from "../parts/ImageWithLoaderPart";
import {
  productDetailDesc,
  productDetailDescStructured,
  productDetailTitle
} from "../utils/SEOUtils";
import SEOInfoPart from "../parts/SEOInfoPart";
import { Helmet } from "react-helmet";
import { getCategoryName, getCategoryNamesTree } from "../utils/CategoryUtils";
import NotFoundPart from "../parts/NotFoundPart";
import TimerPart from "../parts/TimerPart";
import componentLoader from "../utils/ComponentLoader";
import { lazyLoadComponentInViewPort } from "../utils/lazyLoadComponent";
import Skeleton from "react-loading-skeleton";
import FlashOnIcon from "@material-ui/icons/FlashOn";

const ProductsHorizontalSectionPart = lazy(() =>
  componentLoader(import("../parts/ProductsHorizontalSectionPart"))
);

@inject(["uiStore"])
@inject(["productStore"])
@inject(["customerStore"])
@inject(["orderStore"])
@inject(["topSellingStore"])
@inject(["globalSettingStore"])
@inject(["similarProductsStore"])
@inject(["productBasedRecommendationsStore"])
@observer
class ProductDetailPage extends Component {
  state = {
    outOfStockPopup: false,
    activeImageIndex: 0
  };

  componentDidMount() {
    const {
      location: { search, pathname },
      customerStore,
      productStore,
      history
    } = this.props;

    if (
      !customerStore.isLoggedIn &&
      getQueryParam(search, "out-of-stock-reminder")
    ) {
      productStore.toggleCurrentlyNotified();
      history.push("/login?redirect=" + pathname);
    } else {
      this.fetchAll();
    }
  }

  getProduct = product => {
    const { orderStore } = this.props;
    const orderStoreProduct = orderStore.all.get(product.id);
    if (
      orderStoreProduct &&
      orderStoreProduct.id &&
      product.order_quantity !== orderStoreProduct.order_quantity
    ) {
      return { ...product, order_quantity: orderStoreProduct.order_quantity };
    }
    return { ...product };
  };

  fetchAll() {
    const {
      productStore,
      customerStore,
      globalSettingStore,
      uiStore,
      orderStore,
      location: { pathname },
      location: { search }
    } = this.props;
    let prid = getProductIdFromUrl(pathname);

    productStore.fetch(prid, data => {
      if (
        customerStore.isLoggedIn &&
        (getQueryParam(search, "out-of-stock-reminder") ||
          productStore.currentlyNotified)
      ) {
        productStore.toggleCurrentlyNotified();
        productStore.notificationClick(data.vendor_product_id);
      }
      if (
        uiStore.locationChanged &&
        (!productIsAvailable(productStore.item) ||
          !productStore.item.is_current_vendor)
      ) {
        uiStore.setDefaultDeliveryLocation(uiStore.defaultDeliveryLocation);
        this.setState({
          outOfStockPopup: true
        });
      }

      if (
        uiStore.showLocPopup &&
        productStore.isProductDetailClicked &&
        productIsAvailable(productStore.item) &&
        productStore.item.is_current_vendor
      ) {
        uiStore.setShowLocPopup(false);
        orderStore.addOne(
          this.getProduct(productStore.item),
          "Detail Page",
          "Product Detail Page",
          undefined
        );
      }
    });
    globalSettingStore.registerDevice();
  }

  componentDidUpdate(prevProps) {
    const {
      location: { pathname }
    } = this.props;
    let prid = getProductIdFromUrl(pathname);
    let oldPrid = getProductIdFromUrl(prevProps.location.pathname);

    if (prid !== oldPrid) {
      this.setState({ activeImageIndex: 0 });
      this.cancelAll();
      this.fetchAll();
    }
  }

  refreshProduct = product => {
    const {
      props: { productStore }
    } = this;
    if (productStore.item.id === product.id) {
      productStore.item.flash_deal.status =
        productStore.item.flash_deal.status === 1
          ? 2
          : productStore.item.flash_deal.status === 2
          ? 0
          : productStore.item.flash_deal.status;
    }
  };

  handleLoadMore = () => {
    const {
      location: { pathname },
      productBasedRecommendationsStore
    } = this.props;
    let prid = getProductIdFromUrl(pathname);
    productBasedRecommendationsStore.loadMore(prid);
  };

  cancelAll() {
    const { productStore } = this.props;
    productStore.cancel();
  }

  closeOutofStockPopup = () => {
    this.setState({
      outOfStockPopup: false
    });
  };

  componentWillUnmount() {
    this.cancelAll();
  }

  render() {
    const {
      props: {
        classes,
        productStore,
        match,
        topSellingStore,
        similarProductsStore,
        productBasedRecommendationsStore,
        productStore: { item },
        uiStore,
        customerStore,
        location: { pathname }
      },
      state: { outOfStockPopup, activeImageIndex },
      closeOutofStockPopup,
      handleLoadMore
    } = this;
    let prid = getProductIdFromUrl(pathname);
    if (!item) {
      return <div>{match.params.prn}</div>;
    }

    const categoryName = getCategoryName(item.category_id);
    const seoDescription = productDetailDesc(
      item.name,
      item.unit,
      categoryName,
      item.desc,
      item.desc_article
    );
    const seoDescriptionStructured = productDetailDescStructured(
      item.name,
      item.unit,
      categoryName,
      item.desc,
      item.desc_article
    );
    const seoTitle = productDetailTitle(item.name, categoryName);
    const loading = !item.name || productStore.state === "fetching";
    const available = productIsAvailable(item);
    const onSale =
      isFlashDeal(item) || isDeal(item) || !isFlashDealExpired(item);
    const images = available ? getProductAllFullImages(item) : [getImage(item)];
    const activeImage = images[Math.min(activeImageIndex, images.length - 1)];
    const notified = productStore.notifiedItems.includes(
      item.vendor_product_id
    );
    const deliveryArea =
      uiStore.defaultDeliveryLocation &&
      uiStore.defaultDeliveryLocation.location;
    const showClub =
      !isEasyPaisaMiniApp() && !(customerStore.customer || {}).is_member;
    const discount = isFlashDeal(item)
      ? formatDiscount(item.flash_deal.percentage)
      : isDeal(item)
      ? item.deal_percentage
        ? formatDiscount(item.deal_percentage)
        : item.deal_title
      : null;
    const browseSimilar = () =>
      this.props.history.push(getSearchPageUrl(trimStr(item.name, 13)));

    const bottomHorizontalSection = (
      <div className={classes.stack}>
        <Suspense fallback={<div />}>
          <ProductsHorizontalSectionPart
            name="You may also like"
            onScroll={handleLoadMore}
            fetch={() => productBasedRecommendationsStore.fetch(prid)}
            cancel={productBasedRecommendationsStore.cancel}
            state={productBasedRecommendationsStore.fetchState}
            listName="Home Page - More To Love"
            CTListName="Horizontal Section - More To Love"
            products={productBasedRecommendationsStore.all}
          />
        </Suspense>
        <Suspense fallback={<div />}>
          <ProductsHorizontalSectionPart
            name="Most popular"
            state={topSellingStore.fetchState}
            fetch={topSellingStore.fetch}
            cancel={topSellingStore.cancel}
            listName="Detail Page - Most popular"
            CTListName="Horizontal Section - Top Selling"
            products={topSellingStore.all}
          />
        </Suspense>
      </div>
    );

    const flashBadge = (isFlashDeal(item) || hasFlashDealStarted(item)) && (
      <GBadge tone="brand">
        <FlashOnIcon style={{ fontSize: 14 }} aria-hidden="true" />
        {hasFlashDealStarted(item) ? "Flash deal in " : "Flash deal · ends in "}
        <TimerPart
          beforeDeal={hasFlashDealStarted(item)}
          initialTime={timeDiffBreakdown(
            hasFlashDealStarted(item)
              ? item.flash_deal.start_time
              : item.flash_deal.end_time
          )}
          isDone={() => this.refreshProduct(item)}
        />
      </GBadge>
    );

    if (productStore.isFailed) {
      return <NotFoundPart />;
    }

    return (
      <>
        <main className={classes.page}>
          <Helmet>
            <script type="application/ld+json">
              {`{
              "@context": "http://schema.org",
              "@type": "Product",
              "productID": "${getProductId(item)}",
              "mpn": "${getProductId(item)}",
              "name": "${item.name}",
              "description": "${seoDescriptionStructured}",
              "url": "${getProductPageAbsUrl(item)}",
              "image": "${productFullImage(item)}",
              "category": "${getCategoryNamesTree(item.category_id)}",
              "brand": "${firstBrandName(item)}",
              "sku": "${item.barcode}",
              "offers": [
                {
                  "@type": "Offer",
                  "url": "${getProductPageAbsUrl(item)}",
                  "price": "${productPrice(item) || 0}",
                  "priceCurrency": "PKR",
                  "itemCondition": "http://schema.org/NewCondition",
                  "availability": "${productAvailability(item)["json"]}",
                  "eligibleQuantity": "${item.unit}",
                  "seller": {
                    "@type": "Organization",
                    "name": "GrocerApp"
                  }
                }
              ]
            }`}
            </script>
            <script type="application/ld+json">
              {`
            {
              "@context": "http://www.schema.org",
              "@type": "ImageObject",
              "contentUrl": "${productFullImage(item)}",
              "description": "${seoDescriptionStructured}",
              "name": "${item.name}"
            }
          `}
            </script>
            <link rel="canonical" href={getProductPageAbsUrl(item)} />
          </Helmet>

          <div className={classes.top}>
            <BreadcrumbsPart
              isProductDetailPage
              productName={item.name}
              cid={item.category_id}
            />

            {loading ? (
              <div className={classes.detail} aria-hidden="true">
                <Skeleton className={classes.galleryMainSkeleton} />
                <div className={classes.buyBox}>
                  <Skeleton height={16} width={90} />
                  <Skeleton height={36} width="80%" />
                  <Skeleton height={18} width={80} />
                  <Skeleton height={32} width={120} />
                  <Skeleton height={56} width="100%" />
                </div>
              </div>
            ) : (
              <div className={classes.detail}>
                <SEOInfoPart
                  title={seoTitle}
                  description={seoDescription}
                  image={productFullImage(item)}
                  imageAlt={item.name}
                  url={getProductPageAbsUrl(item)}
                />
                <div className={classes.gallery}>
                  <div
                    className={classnames(classes.galleryMain, {
                      [classes.isOut]: !available
                    })}
                  >
                    <ImageWithLoaderPart
                      key={activeImage}
                      src={activeImage}
                      width="600"
                      height="600"
                      alt={item.name}
                      className={classes.galleryImage}
                    />
                    {discount && (
                      <span className={classes.discount}>{discount}</span>
                    )}
                    {!available && (
                      <span className={classes.outLabel}>Out of stock</span>
                    )}
                  </div>
                  {images.length > 1 && (
                    <div
                      className={classes.thumbs}
                      role="group"
                      aria-label="Product images"
                    >
                      {images.map((image, index) => (
                        <button
                          type="button"
                          key={image}
                          className={classnames(classes.thumb, {
                            [classes.thumbActive]: index === activeImageIndex
                          })}
                          aria-label={`Show image ${index + 1} of ${
                            images.length
                          }`}
                          aria-pressed={index === activeImageIndex}
                          onClick={() =>
                            this.setState({ activeImageIndex: index })
                          }
                        >
                          <img src={image} alt="" width="72" height="72" />
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                <div className={classes.buyBox}>
                  {item.brands && item.brands.length > 0 && (
                    <div className={classes.brandLine}>
                      {item.brands.map((brand, index) => (
                        <React.Fragment key={brand.id}>
                          {index > 0 && ", "}
                          <Link to={getBrandPageUrl(brand.slug)}>
                            {brand.name}
                          </Link>
                        </React.Fragment>
                      ))}
                    </div>
                  )}
                  <h1 className={classes.productName}>{item.name}</h1>
                  {item.unit && (
                    <span className={classes.pack}>
                      {formatPackSize(item.unit)}
                    </span>
                  )}
                  {flashBadge}
                  <div className={classes.priceRow}>
                    <span className={classes.price}>
                      {formatPrice(
                        onSale ? dealPrice(item) : productPrice(item)
                      )}
                    </span>
                    {onSale && (
                      <span className={classes.was}>
                        {formatPrice(productPrice(item))}
                      </span>
                    )}
                  </div>

                  <div className={classes.actions}>
                    {available ? (
                      <AddToCartButtonPart
                        variant="lg"
                        listName="Detail Page"
                        CTListName="Product Detail Page"
                        product={item}
                      />
                    ) : (
                      <GButton
                        size="lg"
                        fullWidth
                        variant="outline"
                        disabled={notified}
                        onClick={() =>
                          remindMe(this.props, item, getProductPageUrl(item))
                        }
                      >
                        {notified
                          ? "We'll notify you"
                          : "Notify me when it's back"}
                      </GButton>
                    )}
                    {(!available || !item.is_current_vendor) && (
                      <GButton
                        size="lg"
                        fullWidth
                        variant="secondary"
                        onClick={browseSimilar}
                      >
                        Browse similar products
                      </GButton>
                    )}
                  </div>

                  <div className={classes.infoRows}>
                    {deliveryArea && (
                      <GRow
                        icon={<LocalShippingOutlined />}
                        title="Delivery"
                        subtitle={`To ${deliveryArea}`}
                        to={`/change-location?redirect=${getProductPageUrl(
                          item
                        )}`}
                      />
                    )}
                    {showClub && (
                      <GRow
                        icon={<CardMembership />}
                        title="Free delivery with Membership"
                        subtitle="Learn more"
                        to="/membership"
                      />
                    )}
                    <GRow
                      icon={<AssignmentReturnOutlined />}
                      title="Easy returns"
                      subtitle="Return damaged items at the door"
                      to="/return-and-refund-policy"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

          <section className={classes.about}>
            <h2 className={classes.sectionTitle}>About this item</h2>
            <p className={classes.aboutText}>
              Buy {item.name} online from GrocerApp. The price of {item.name} in
              Pakistan is{" "}
              {formatPrice(isDeal(item) ? dealPrice(item) : productPrice(item))}{" "}
              at GrocerApp. Shop {item.name} online and get delivery in Lahore,
              Islamabad, Rawalpindi and Faisalabad.
            </p>
            <dl className={classes.specs}>
              {firstBrandName(item) && (
                <div>
                  <dt>Brand</dt>
                  <dd>{firstBrandName(item)}</dd>
                </div>
              )}
              {item.unit && (
                <div>
                  <dt>Pack</dt>
                  <dd>{formatPackSize(item.unit)}</dd>
                </div>
              )}
              {categoryName && (
                <div>
                  <dt>Category</dt>
                  <dd>{categoryName}</dd>
                </div>
              )}
            </dl>
          </section>

          {lazyLoadComponentInViewPort(
            <Suspense fallback={<div />}>
              <ProductsHorizontalSectionPart
                name={categoryName ? `More ${categoryName}` : "More like this"}
                fetch={() => similarProductsStore.fetch(prid)}
                cancel={similarProductsStore.cancel}
                state={similarProductsStore.fetchState}
                listName="Detail Page - Similar Products"
                CTListName="Horizontal Section - Similar Products"
                products={similarProductsStore.all}
              />
            </Suspense>,
            { once: true, resize: true, height: 200, style: { width: "100%" } }
          )}
          {lazyLoadComponentInViewPort(bottomHorizontalSection, {
            once: true,
            resize: true,
            height: 200,
            style: { width: "100%" }
          })}
        </main>

        <GDialog
          open={outOfStockPopup}
          onClose={closeOutofStockPopup}
          title="Not available in your area"
          cancelLabel="Close"
          confirmLabel="Browse similar products"
          onConfirm={browseSimilar}
        >
          Sorry, this product isn&apos;t available at your delivery location.
        </GDialog>
      </>
    );
  }
}

export default withSnackbar(withCustomStyles(ProductDetailPage));
